// analytics.ts

import ReactGA from 'react-ga4';

const GA_MEASUREMENT_ID = 'G-0BCHFMQXKT';

export const initializeAnalytics = (): void => {
  ReactGA.initialize(GA_MEASUREMENT_ID);
};

export const logPageView = (path?: string, title?: string): void => {
  ReactGA.send({
    hitType: 'pageview',
    page: path || window.location.pathname,
    title: title || document.title,
  });
};

export const logEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number,
): void => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
